var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGreenBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1768 12.1913V5.8107C15.1765 5.53097 15.1026 5.25623 14.9626 5.01405C14.8226 4.77186 14.6214 4.57075 14.3792 4.43089L8.79611 1.24057C8.55362 1.10056 8.27854 1.02686 7.99853 1.02686C7.71853 1.02686 7.44345 1.10056 7.20095 1.24057L1.61789 4.43089C1.37564 4.57075 1.17442 4.77186 1.03443 5.01405C0.894442 5.25623 0.820599 5.53097 0.820312 5.8107V12.1913C0.820599 12.4711 0.894442 12.7458 1.03443 12.988C1.17442 13.2302 1.37564 13.4313 1.61789 13.5712L7.20095 16.7615C7.44345 16.9015 7.71853 16.9752 7.99853 16.9752C8.27854 16.9752 8.55362 16.9015 8.79611 16.7615L14.3792 13.5712C14.6214 13.4313 14.8226 13.2302 14.9626 12.988C15.1026 12.7458 15.1765 12.4711 15.1768 12.1913Z",
    stroke: "#087E38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.03516 4.98145L7.99803 9.00923L14.9609 4.98145",
    stroke: "#087E38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17.0401V9.00049",
    stroke: "#087E38",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenBox);
export default __webpack_public_path__ + "static/media/green-box.2c2322aeffdb4f86af5553d9d0878d5b.svg";
export { ForwardRef as ReactComponent };